//#region src/utils/is-image.ts
var e = [
	"jpg",
	"jpeg",
	"png",
	"gif",
	"bmp",
	"webp",
	"svg",
	"tiff",
	"ico",
	"avif"
];
function t(t) {
	let n = t.name.split(".").pop()?.toLowerCase();
	return t.type.startsWith("image/") || e.includes(n ?? "-");
}
//#endregion
export { t as isImageFile };
